// socket.js
import { io } from "socket.io-client";
import config from "config/config";

let socket;

export const connectSocket = (role) => {
  if (role !== "R011") {
    return null;
  }

  if (!socket) {
    const baseUrl = new URL(config.host).origin;
    socket = io(`${baseUrl}`, {
      transports: ["websocket"],
    });

    socket.on("connect", () => {
      console.log("Socket connected with id:", socket.id);
    });

    socket.on("connect_error", (err) => {
      console.error("Socket connection error:", err);
    });

    socket.on("disconnect", (reason) => {
      console.log("Socket disconnected:", reason);
    });
  }
  return socket;
};
